module.exports = __webpack_public_path__ + "img/jinao.dd4f5570.png";